import moment from 'moment';

const AREA_CODES = [
  { id: '11', label: '北京' },
  { id: '12', label: '天津' },
  { id: '13', label: '河北' },
  { id: '14', label: '山西' },
  { id: '15', label: '内蒙古' },
  { id: '21', label: '辽宁' },
  { id: '22', label: '吉林' },
  { id: '23', label: '黑龙江' },
  { id: '31', label: '上海' },
  { id: '32', label: '江苏' },
  { id: '33', label: '浙江' },
  { id: '34', label: '安徽' },
  { id: '35', label: '福建' },
  { id: '36', label: '江西' },
  { id: '37', label: '山东' },
  { id: '41', label: '河南' },
  { id: '42', label: '湖北' },
  { id: '43', label: '湖南' },
  { id: '44', label: '广东' },
  { id: '45', label: '广西' },
  { id: '46', label: '海南' },
  { id: '50', label: '重庆' },
  { id: '51', label: '四川' },
  { id: '52', label: '贵州' },
  { id: '53', label: '云南' },
  { id: '54', label: '西藏' },
  { id: '61', label: '陕西' },
  { id: '62', label: '甘肃' },
  { id: '63', label: '青海' },
  { id: '64', label: '宁夏' },
  { id: '65', label: '新疆' },
  { id: '71', label: '台湾' },
  { id: '81', label: '香港' },
  { id: '82', label: '澳门' }
];


function isIdNo(value) {
  var isId = /^([1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2]\d)|3[0-1])\d{3})|([1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2]\d)|3[0-1])\d{3}([0-9]|X))$/.test(value);

  if (isId) {
    var areaCode = AREA_CODES.find(code => code.id == value.substr(0, 2));
    var validAreaCode = areaCode && areaCode.label;
    var isBirthday = validBirthday(birthdayOf(value));
    isId = validAreaCode && isBirthday;
  }

  return isId;
}


function birthdayOf(personalId) {
  if (!personalId) {
    return null;
  }
  var birthday = '';
  if (personalId.length == 15) {
    // 旧身份证
    birthday = personalId.replace(/^\d+(\d{2})(\d{2})(\d{2}).{3}$/, '19$1-$2-$3');
    return moment(birthday);
  } else if (personalId.length == 18) {
    // 新身份证
    birthday = personalId.replace(/^\d+(\d{4})(\d{2})(\d{2}).{4}$/, '$1-$2-$3');
    return moment(birthday)
  } else {
    return null;
  }
};
function validBirthday(birthday) {
  if (!birthday) {
    return false;
  }
  return moment(birthday).local().startOf('d').add(120, 'y').isAfter(moment().local().startOf('d').add(1, 'd'));
}


export default isIdNo;



// WEBPACK FOOTER //
// ./components/forms/is-id-no.js